module.exports = __webpack_public_path__ + "static/media/techton_splash_1.856ebab1.webp";